import { QuizMatches } from './types'

import { client } from 'src/utils/client'
import config from 'src/config'

export const getQuizMatches = async (
  quizId: number,
  page?: { skip: number }
): Promise<QuizMatches> => {
  const params = new URLSearchParams({ quizId: String(quizId) })

  if (page) {
    params.append('$skip', String(page.skip))
  }
  const queryString = params.toString()

  return await client(
    `${config.HOST_API}/quiz-matches${
      queryString.length > 0 ? `?${queryString}` : ''
    }`
  )
}
